import { DocumentIcon } from '@heroicons/react/24/solid';
import { When } from 'react-if';

import { Modal } from '../Atoms/Modal';
import { Paragraph } from '../Atoms/Typography/Paragraph';
import { SmallSpinner } from '../Atoms/SmallSpinner';
import { Button } from '../Atoms/Button';

interface AttachmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  attachments: string[];
  isLoading: boolean;
  onDownloadAttachment: () => void;
  isDownloading?: boolean;
}

export function AttachmentsModal({
  isOpen,
  onClose,
  attachments,
  isLoading,
  onDownloadAttachment,
  isDownloading,
}: AttachmentsModalProps) {
  return (
    <Modal
      title={ `Invoice Attachments` }
      open={ isOpen }
      setOpen={ onClose }
    >
      <When condition={ isLoading }>
        <div className={ `flex flex-col justify-center items-center py-8` }>
          <SmallSpinner colored
            size={ `lg` } />
          <Paragraph variant={ `secondary` }
            className={ `mt-2` }>
            { `Loading attachments...` }
          </Paragraph>
        </div>
      </When>

      <When condition={ !isLoading && attachments.length === 0 }>
        <div className={ `py-8 text-center` }>
          <DocumentIcon className={ `mx-auto h-12 w-12 text-gray-400` } />
          <Paragraph variant={ `secondary` }
            className={ `mt-2` }>
            { `No attachments found for this invoice.` }
          </Paragraph>
        </div>
      </When>

      <When condition={ !isLoading && attachments.length > 0 }>
        <div>
          <ul className={ `divide-y divide-gray-200 mb-4` }>
            { attachments.map((attachment, index) => (
              <li key={ index }
                className={ `py-3 flex` }>
                <DocumentIcon className={ `h-5 w-5 text-gray-400 mt-0.5 mr-2` } />
                <div>
                  <Paragraph>{ attachment }</Paragraph>
                </div>
              </li>
            )) }
          </ul>

          <div className={ `flex justify-end pt-3 border-t border-gray-200` }>
            <Button
              onClick={ () => onDownloadAttachment() }
              loading={ isDownloading }
            >
              { `Download Zip` }
            </Button>
          </div>
        </div>
      </When>
    </Modal>
  );
}
